<template>
    <Modal class="modal modal--mob modal-radio-buttons">
        <template #header>
            <h2>{{$t('form_fields.income_label')}}</h2>
        </template>
        <template #body>
            <div v-for="i in yearlyIncome" :key="i.code" class="radiobox">
                <input class="form-check-input" type="radio" :id="i.code" :checked="value === i.value">
                <label @click="update(i.value)" class="radiobox__label" :for="i.code">
                    {{$t(`form_fields.income_options_${i.value}`)}}
                </label>
            </div>
        </template>
        <template #footer>
            <a @click="$emit('success')" class="skip">{{$t('credits.skip_for_now')}}</a>
        </template>
    </Modal>
</template>

<script>

import Modal from "@/components/generic/Modal";
import { yearlyIncome } from "@/service/forms"
import AuthenticatedMixin from "@/mixins/AuthenticatedMixin";

export default {
    name: "OnDemandYearlyIncome",
    mixins: [AuthenticatedMixin],
    components: { Modal },
    props: {
        value: {
            type: [Number, null],
            required: true
        }
    },

    methods: {

        update(value) {

            this.$emit('set', {
                income: value
            })

        }

    },

    created() {
        this.yearlyIncome = yearlyIncome
    },
    mounted() {
        this.icome = this.auth.user.income
    },
    beforeUnmount() {
        clearTimeout(this.timeout)
    }
}
</script>